import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type {
  FetchUpcomingPaymentsParams,
  UpcomingPaymentsResponse,
} from './types';

export const fetchUpcomingPaymentsAPI = async (
  params: FetchUpcomingPaymentsParams,
): Promise<UpcomingPaymentsResponse> => {
  const { page = 1, limit = 10, dueDate } = params;

  const response = await baseAPI.get<UpcomingPaymentsResponse>(
    'subscription-invoices/fetch-upcoming-payments',
    {
      params: {
        page,
        limit,
        dueDate,
      },
    },
  );

  return response.data;
};

export const downloadUpcomingPaymentsCSVAPI = async (params: {
  dueDate: string;
  page?: number;
  limit?: number;
}): Promise<Blob> => {
  const { page = 1, limit = 1000, dueDate } = params;

  const response = await baseAPI.get(
    'subscription-invoices/fetch-upcoming-payments',
    {
      params: {
        page,
        limit,
        dueDate,
        csv: true,
      },
      responseType: 'blob',
    },
  );

  return response.data;
};

export const useFetchUpcomingPayments = (
  params: FetchUpcomingPaymentsParams,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.UPCOMING_PAYMENTS(params),
    queryFn: () => fetchUpcomingPaymentsAPI(params),
    enabled: !!params.dueDate && !!params.page && !!params.limit,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
